import { render, staticRenderFns } from "./AdminExpenseTitle.vue?vue&type=template&id=804be88e&"
import script from "./AdminExpenseTitle.vue?vue&type=script&lang=js&"
export * from "./AdminExpenseTitle.vue?vue&type=script&lang=js&"
import style0 from "./AdminExpenseTitle.vue?vue&type=style&index=0&id=804be88e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports